import * as React from 'react';

import { cn } from '../../utils/cn';

export type InputProps = React.InputHTMLAttributes<HTMLInputElement>;

const Input = React.forwardRef<HTMLInputElement, InputProps>(({ className, type, ...props }, ref) => {
  return (
    <input
      type={type}
      className={cn(
        'h-[54px] w-full rounded-[12px] border-[1.5px] border-[var(--line)] bg-surface px-4 text-[16px] text-[var(--ink)] outline-none transition-[border-color,box-shadow] duration-150 placeholder:text-[var(--ink-3)] placeholder:opacity-85 hover:border-[var(--line-2)] focus:border-brand-blue focus:ring-4 focus:ring-[rgba(0,113,189,0.12)] aria-[invalid=true]:border-loss aria-[invalid=true]:focus:border-loss aria-[invalid=true]:focus:ring-[rgba(229,72,77,0.12)] disabled:cursor-not-allowed disabled:opacity-50',
        className
      )}
      ref={ref}
      {...props}
    />
  );
});
Input.displayName = 'Input';

export { Input };
